import { render, staticRenderFns } from "./UpdateRiskViewpoint.vue?vue&type=template&id=06e092e6&scoped=true"
import script from "./UpdateRiskViewpoint.vue?vue&type=script&lang=js"
export * from "./UpdateRiskViewpoint.vue?vue&type=script&lang=js"
import style0 from "./UpdateRiskViewpoint.vue?vue&type=style&index=0&id=06e092e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e092e6",
  null
  
)

export default component.exports